



























































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import { AppModule } from '@/store/modules/app';
import { SpecOutDetailsModule } from '@/store/modules/specOutDetails';
import SpecOutDto from '@/models/SpecOuts/SpecOutDto';
import { SpecOutListModule } from '@/store/modules/specOutList';
import PageNames from '@/router/PageNames';
import CreateSpecOutRequest from '@/models/SpecOuts/CreateSpecOutRequest';
import EmailTemplateType from '@/models/EmailTemplates/EmailTemplateType';
import EmailTemplateDto from '@/models/EmailTemplates/EmailTemplateDto';
import DeskDto from '@/models/Desks/DeskDto';
import BranchDto from '@/models/Branches/BranchDto';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';

@Component({
    name: 'SpecOutCreate'
})
export default class SpecOutCreate extends GiganautVueDialog {

  entity: SpecOutDto = new SpecOutDto();
  desks: DeskDto[] = [];

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new SpecOutDto();
      this.entity.owner = null;
      this.entity.branch = null;
      this.desks = [];
      await AgencySettingsModule.getBranches();
      await AgencySettingsModule.getAgencyUsers();
      await AgencySettingsModule.getEmailTemplates();
      await SpecOutDetailsModule.searchWorkerProfiles();
      // Default owner to current logged-in agency user
      const currentUserId = AppModule.userProfile ? AppModule.userProfile.agencyUserId : null;
      if (currentUserId) {
        const found = this.agencyUsers.find((u: any) => u.id === currentUserId);
        if (found) {
          this.entity.owner = found;
        }
      }
    }
  }

  @Watch('entity.workerId')
  onWorkerChanged(newVal: string, oldVal: string) {
    if (newVal && newVal !== oldVal) {
      const workerProfile = this.workerProfiles.find((w: WorkerProfileDto) => w.id === newVal);
      if (workerProfile) {
        // Auto-populate branch from worker default
        if (workerProfile.defaultBranchId) {
          const branch = this.branches.find((b: BranchDto) => b.id === workerProfile.defaultBranchId);
          if (branch) {
            this.entity.branch = branch;
            // Auto-populate desk from worker default
            if (workerProfile.defaultDeskId) {
              const desk = branch.desks.find((d: DeskDto) => d.id === workerProfile.defaultDeskId);
              if (desk) {
                this.entity.desk = desk;
              }
            }
          }
        }
      }
    }
  }

  @Watch('entity.branch')
  onBranchChanged(newVal: BranchDto, oldVal: BranchDto) {
    if (newVal) {
      this.desks = newVal.desks;
    } else {
      this.entity.desk = null;
      this.desks = [];
    }
  }

  get agencyUsers() {
    return AgencySettingsModule.agencyUsers;
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get workerProfiles() {
    return SpecOutDetailsModule.workerProfiles;
  }

  get filteredEmailTemplates() {
    return AgencySettingsModule.emailTemplates.filter(
      (t: EmailTemplateDto) => t.type === EmailTemplateType.ContactWorkerSendOut
    );
  }

  get loading() {
    return SpecOutListModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new CreateSpecOutRequest()
    if (this.entity.owner) {
      request.ownerId = this.entity.owner.id;
    }
    if (this.entity.branch) {
      request.branchId = this.entity.branch.id;
    } else {
      request.branchId = '';
    }
    if (this.entity.desk) {
      request.deskId = this.entity.desk.id;
    } else {
      request.deskId = null;
    }
    request.emailTemplateId = this.entity.emailTemplate.id;
    request.emailBccUser = this.entity.emailBccUser;
    request.isTest = this.entity.isTest;
    request.testEmailAddresses = this.entity.testEmailAddresses;
    request.workerId = this.entity.workerId;
    await SpecOutListModule.createSpecOut(request)
    if (SpecOutListModule.newSpecOutId !== '') {
      this.$router.push({ name: PageNames.AgencySpecOutDetails, params: { specoutid: SpecOutListModule.newSpecOutId } });
    }
    this.dialog = false;
  }
}
